import { MarginTable } from "@/components/margin/table";
import { useListMargins } from "@/hooks/api/margin/useListMargins";
import { AppPage } from "@/layouts/page";

export const MarginsPage = () => {
  const { data } = useListMargins();
  const count = (data as unknown[] | undefined)?.length;

  return (
    <AppPage
      subtitle={
        count === undefined ? (
          "Configure profit margins for products"
        ) : (
          <>
            <span className="tabular-nums">{count}</span> price{" "}
            {count === 1 ? "range" : "ranges"}, each with its own profit margin
          </>
        )
      }
      title="Margins"
    >
      <MarginTable />
    </AppPage>
  );
};
